import { render, staticRenderFns } from "./WomenOrMen.vue?vue&type=template&id=bebd6f30&scoped=true&"
import script from "./WomenOrMen.vue?vue&type=script&lang=js&"
export * from "./WomenOrMen.vue?vue&type=script&lang=js&"
import style0 from "./WomenOrMen.vue?vue&type=style&index=0&id=bebd6f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebd6f30",
  null
  
)

export default component.exports